import React from "react";
import { Col, Row, Card, CardBody, ListGroup, ListGroupItem } from "reactstrap";

const IntroductionTalkingBadge = () => {
  return (
    <Row className="mb-4">
      {/* Left Column: Steps */}
      <Col lg="8" className="mb-3">
        <Card className="border-0 shadow-sm rounded-4 h-100">
          <CardBody className="p-4">
            <h3 className="mb-3 text-primary d-flex align-items-center font-weight-bold">
              <i className="fas fa-list-ol mr-2 text-primary"></i>
              Template & Instructions for Talking Badges
            </h3>
            <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>
              Entertain your viewers by linking a YouTube video to your Talking Badge. Follow these simple steps:
            </p>
            <ListGroup className="list-group-flush">
              {[
                "Make a video of yourself introducing your series of Talking Badges.",
                "Upload your selfie intro video to YouTube.",
                "Copy the 'intro video' URL.",
                "Make a QR code from the selfie intro video URL.",
                "Input the 'selfie intro QR' into template #1 (LEFT SIDE) position of your Talking Badge.",
                "Find a YouTube video that you love or make a video of your own and store on YouTube.",
                "Copy the URL.",
                "Make a QR code from the 'I love it' URL.",
                "Input the 'I love it' QR code into template #2 (RIGHT SIDE) of your Talking Badge."
              ].map((step, idx) => (
                <ListGroupItem key={idx} className="border-0 px-0 py-2 d-flex align-items-start bg-transparent">
                  <span 
                    className="d-flex align-items-center justify-content-center bg-primary-light text-primary rounded-circle mr-3 font-weight-bold"
                    style={{
                      minWidth: "24px",
                      height: "24px",
                      fontSize: "12px",
                      backgroundColor: "#eef2ff",
                      color: "#5e72e4"
                    }}
                  >
                    {idx + 1}
                  </span>
                  <span className="text-dark" style={{ fontSize: "0.9rem", lineHeight: "1.4" }}>
                    {step}
                  </span>
                </ListGroupItem>
              ))}
            </ListGroup>
          </CardBody>
        </Card>
      </Col>

      {/* Right Column: Script */}
      <Col lg="4" className="mb-3">
        <Card className="border-0 shadow-sm rounded-4 h-100 bg-white">
          <CardBody className="p-4 d-flex flex-column justify-content-between">
            <div>
              <h3 className="mb-3 d-flex align-items-center font-weight-bold" style={{ color: "#2dce89" }}>
                <i className="fas fa-file-signature mr-2"></i>
                Selfie Intro Script
              </h3>
              <p className="text-muted mb-4" style={{ fontSize: "0.875rem" }}>
                Use this template script when recording your selfie introduction video:
              </p>
              <div 
                className="p-4 position-relative" 
                style={{ 
                  borderLeft: "4px solid #2dce89",
                  fontStyle: "italic",
                  fontSize: "0.95rem",
                  lineHeight: "1.7",
                  backgroundColor: "#f0fdf4",
                  borderRadius: "0 8px 8px 0"
                }}
              >
                <p className="text-dark mb-0 font-weight-500">
                  "Hi, My name is <strong className="text-primary text-underline" style={{ borderBottom: "1.5px solid #5e72e4" }}>_______</strong>. In my Talking Badges, I promise to deliver for my fans the most entertaining videos I can find. Please buy one each of my Talking Badges so I can keep delivering them to you. Thanks to my fans. I Love you guys!"
                </p>
              </div>
            </div>
            <div className="mt-4 pt-3 border-top border-light text-center">
              <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                <i className="fas fa-video mr-1 text-success"></i> Be creative & have fun!
              </span>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default IntroductionTalkingBadge;
